import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { useCalculationsStore } from '../store/calculations';
import { useClientsStore } from '../store/clients';

import { calculationSchema } from '../utils/schemas';
import { calculationService } from '../utils/api/calculationService';

export function useCalculationFileHandler() {
  const toast = useToast();

  const calculationStore = useCalculationsStore();
  const clientStore = useClientsStore();

  const isLoading = ref(false);

  async function addCalculationFromFile(data: object) {
    try {
      isLoading.value = true;

      const calculation = calculationSchema.parse(data);

      if (!clientStore.getClientByUuid(calculation.client_uuid)) {
        throw Error('Nie znaleziono klienta z podanym uuid. Dodaj najpierw klienta');
      }

      const updatedCalculation = await calculationService.saveCalculation(calculation);

      if (calculationStore.getCalculationByUuid(calculation.uuid)) {
        calculationStore.saveCalculation(updatedCalculation);
      } else {
        calculationStore.appendCalculation(updatedCalculation);
      }

      toast.add({
        severity: 'success',
        summary: 'Dodane kalkulacji zostały zaktualizowane',
        life: 3000,
      });
    } catch (error) {
      console.error(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas zapisywania klienta',
        life: 3000,
      });
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    addCalculationFromFile,
  };
}
